import React, { useState } from "react";
import {
  Box,
  Drawer,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Typography,
  IconButton,
  AppBar,
  Toolbar,
  useMediaQuery,
} from "@mui/material";
import DashboardIcon from "@mui/icons-material/Dashboard";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import AssignmentIcon from "@mui/icons-material/Assignment";
import DirectionsBoatIcon from "@mui/icons-material/DirectionsBoat";
import LogoutIcon from "@mui/icons-material/Logout";
import GroupAddIcon from "@mui/icons-material/GroupAdd";
import LoginIcon from "@mui/icons-material/Login";
import SailingIcon from "@mui/icons-material/Sailing";
import MenuIcon from "@mui/icons-material/Menu"; // Toggle icon
import { Outlet, useNavigate } from "react-router-dom";
import UploadIcon from "@mui/icons-material/Upload"; // Icon for uploading CVs
import { Collapse } from "@mui/material";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";

const drawerWidth = 260;

const menuItems = [

  { text: "Dashboard", icon: <DashboardIcon />, path: "dashboard" },
  { text: "Profile", icon: <AccountCircleIcon />, path: "profile" },
  { text: "Bankdetails", icon: <AccountBalanceIcon />, path: "bankdetails" },
  { text: "Assigned Vessels", icon: <DirectionsBoatIcon />, path: "AssignedVessels" },
  { text: "Assigned Crews", icon: <GroupAddIcon />, path: "AssignedCrewToAgent" },
  { text: "SignIn / SignOff", icon: <LoginIcon />, path: "Signinsignoffcrewingagent" },
  { text: "Upload Crew CVs", icon: <UploadIcon />, path: "upload-cv" },
  { text: "Get All uploaded CVs", icon: <GroupAddIcon />, path: "get-uploaded-cvs" },
  { text: "Selected CVs", icon: <GroupAddIcon />, path: "get-matched-cvs" },
  { text: "Sea-Service", icon: <SailingIcon />, path: "Seaservicecrewing" },

  {
    text: "Executive",
    icon: <AccountCircleIcon />,
    children: [
      { text: "Add Executive", path: "executive/add" },
      { text: "List of Executive", path: "executive/list" },
    ],
  },

  { text: "Logout", icon: <LogoutIcon />, path: "/logout", logout: true },

];

const CrewingAgentDrawer = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [drawerOpen, setDrawerOpen] = useState(true);
  const navigate = useNavigate();
  const isMobile = useMediaQuery("(max-width:900px)");
  const [openExecutive, setOpenExecutive] = useState(false);

  const toggleDrawer = () => {
    setDrawerOpen(!drawerOpen);
  };

  const drawerContent = (
    <>
      <Typography
        variant="h6"
        sx={{
          p: 2,
          fontWeight: "bold",
          textAlign: "center",
          borderBottom: "1px solid rgba(255,255,255,0.2)",
        }}
      >
        Crewing Agent Panel
      </Typography>

      <List sx={{ mt: 1 }}>
        {menuItems.map((item, index) => (
          <React.Fragment key={index}>
            {!item.children ? (
              <ListItemButton
                onClick={() => {
                  setActiveIndex(index);
                  navigate(item.path);
                  if (isMobile) setDrawerOpen(false);
                }}
                sx={{
                  color: "white",
                  borderRadius: "8px",
                  mx: 1,
                  my: 0.5,
                  backgroundColor:
                    activeIndex === index ? "rgba(255,255,255,0.2)" : "transparent",
                  "&:hover": { backgroundColor: "rgba(255,255,255,0.15)" },
                }}
              >
                <ListItemIcon sx={{ color: "white" }}>{item.icon}</ListItemIcon>
                <ListItemText primary={item.text} />
              </ListItemButton>
            ) : (
              <>
                {/* Executive Parent */}
                <ListItemButton onClick={() => setOpenExecutive(!openExecutive)}>
                  <ListItemIcon sx={{ color: "white" }}>{item.icon}</ListItemIcon>
                  <ListItemText primary={item.text} />
                  {openExecutive ? <ExpandLess /> : <ExpandMore />}
                </ListItemButton>

                <Collapse in={openExecutive} timeout="auto" unmountOnExit>
                  <List component="div" disablePadding>
                    {item.children.map((child, childIndex) => (
                      <ListItemButton
                        key={childIndex}
                        sx={{ pl: 6, color: "white" }}
                        onClick={() => {
                          navigate(child.path);
                          if (isMobile) setDrawerOpen(false);
                        }}
                      >
                        <ListItemText primary={child.text} />
                      </ListItemButton>
                    ))}
                  </List>
                </Collapse>
              </>
            )}
          </React.Fragment>
        ))}
      </List>

    </>
  );

  return (
    <Box sx={{ display: "flex", minHeight: "100vh", }}>
      {/* AppBar (Menu button always visible) */}
      <AppBar
        position="fixed"
        sx={{
          background: "linear-gradient(90deg, #C30B12, #a50a10)",
          zIndex: (theme) => theme.zIndex.drawer + 1,
        }}
      >
        <Toolbar>
          <IconButton
            color="inherit"
            edge="start"
            onClick={toggleDrawer}
            sx={{ mr: 2 }}
          >
            <MenuIcon />
          </IconButton>
          <Typography variant="h6" noWrap>
            Crewing Agent Panel
          </Typography>
        </Toolbar>
      </AppBar>

      {/* Drawer */}
      <Drawer
        variant={isMobile ? "temporary" : "persistent"} // persistent for desktop
        open={drawerOpen}
        onClose={toggleDrawer}
        sx={{
          width: drawerWidth,
          flexShrink: 0,
          "& .MuiDrawer-paper": {
            width: drawerWidth,
            boxSizing: "border-box",
            background: "linear-gradient(180deg, #C30B12, #a50a10)",
            color: "white",
            borderRight: "none",
          },
        }}
      >
        {drawerContent}
      </Drawer>

      {/* Main Content */}
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          width: drawerOpen && !isMobile ? `calc(100% - ${drawerWidth}px)` : "100%",
          p: 4,
          backgroundColor: "#f4f6f8",
          mt: 8, // push down content under AppBar
          transition: "width 0.3s ease",
        }}
      >
        <Outlet />
      </Box>
    </Box>
  );
};

export default CrewingAgentDrawer;
